import { replaceString } from 'src/api/demo';

const { useEffect, useRef, useState } = require('react');
const { useLocation } = require('react-router-dom');

const useGetProfile = () => {
  const [profileRef, setProfileRef] = useState({});
  const location = useLocation();
  const updateProfileRef = () => {
    const authToken = JSON.parse(localStorage.getItem('User')) || {};

    const getProfile =
    String(window.location.href).indexOf('blinkit') > -1 ?
    JSON.parse(sessionStorage.getItem('blinkitProfile'))
    :String(window.location.href).indexOf('instamart') > -1 ?
    JSON.parse(sessionStorage.getItem('instamartProfile'))
    : String(window.location.href).indexOf('myntra') > -1 ?
    JSON.parse(sessionStorage.getItem('myntraProfile'))
    : String(window.location.href).indexOf('flipkart') > -1
        ? JSON.parse(sessionStorage.getItem('flipkartProfile'))
        : String(window.location.href).indexOf('zepto') > -1 ?
        JSON.parse(sessionStorage.getItem('zeptoProfile'))
        : String(window.location.href).indexOf('bigbasket') > -1 ?
        JSON.parse(sessionStorage.getItem('bigbasketProfile'))
        : JSON.parse(sessionStorage.getItem('selectedProfileId'));
    console.log("useGetProfile", getProfile)
    if (authToken && process.env.REACT_APP_DEMO_EMAIL && process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken?.email) > -1) {
      const newProfile = JSON.parse(replaceString(JSON.stringify(getProfile)));
      setProfileRef({ ...newProfile });
    } else {
      setProfileRef({ ...getProfile });
    }
  };
  
  useEffect(() => {
    console.log("updateProfileRef")
    updateProfileRef()
    window.addEventListener('storage', updateProfileRef);
    return () => {
      window.removeEventListener('storage', updateProfileRef);
    };
  }, [window.location.href, location.pathname]);

  return [profileRef];
};

export default useGetProfile;
